<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
        <v-flex xs10>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs2>
          <report-list-actions
          :reportOptions="reportOptions"
          :downloadFilename="reportListFilename"
          ></report-list-actions>
        </v-flex>

        <v-flex xs12>
          <h3 class="text-center mb-5">Staff</h3>
          <v-divider class="ml-4 mr-4 mb-3"></v-divider>
        </v-flex>

        <v-row>
          <v-card class="ma-3 pa-3" elevation="0">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="12" sm="12" md="11">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-select
                          label="Select Program"
                          :items="programsSelection"
                          item-text="Name"
                          item-value="Name"
                          v-model="reportFilters.filterProgram"
                          clearable
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-select
                          label="Select role"
                          :items="filteredPositions"
                          v-model="reportFilters.filterRole"
                          clearable
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" sm="12" md="1">
                    <v-btn block class="mt-4 mb-4 pl-5" @click="getEmployees()">
                      Search
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-row>

        <v-flex xs12 class="pa-2">
          <v-data-table
            :headers="headers"
            :items="employees"
            sort-by="Name"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Staff"
            width="80%"
            :items-per-page="10"
            :page="page"
            :pageCount="pageCount"
            :server-items-length="itemCount"
            :options.sync="options"
          >
          <template v-slot:item.Program="{ item }">
              <div style="word-break: break-word;">
                <span v-for="(programLabel, index) in item.Program" :key="index">
                  {{ programLabel.trim() }}{{ programLabel.trim() == '' || item.Program.length -1 == index  ? '' : ','}}
                </span>
              </div>
            </template>
            <template v-slot:item.select="{ item }">
              <v-btn
                x-small
                class="white--text"
                color="#2b3990"
                @click="viewEmployee(item)"
              >
                view
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialog" max-width="100%">
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="newName"
                    label="Staff Name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="newPhone"
                    label="Phone Number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="newPhoneCarrier"
                    label="Phone Carrier"
                    :rules="requiredField"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="newEmail"
                        label="Email"
                        v-on="on"
                        :disabled="editEmail"
                        :rules="emailRules"
                      ></v-text-field>
                    </template>
                    <span
                      >This email will be used to login in the account.</span
                    >
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="newPassword"
                    type="password"
                    label="Password"
                    :rules="requiredField"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="newRePass"
                    type="password"
                    label="Retype Password"
                    :rules="requiredField"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-menu offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Date Hired"
                        v-on="on"
                        :value="newDate"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="newDate" scrollable></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="newAddress"
                    label="Address"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field v-model="newCity" label="City"></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field v-model="newState" label="State"></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field v-model="newZip" label="Zip"></v-text-field>
                </v-col>
                <!-- <v-col class="d-flex" cols="12" sm="6">
                                        <v-autocomplete
                                        :items="position"
                                        outlined
                                        label="Position"
                                        v-model="newPosition"
                                        ></v-autocomplete>
                                    </v-col> -->
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    :items="droles"
                    label="Role"
                    outlined
                    v-model="newRole"
                  ></v-select>
                </v-col>
                <v-col
                  class="d-flex"
                  cols="12"
                  sm="6"
                  v-if="Role == 'Administration'"
                >
                  <v-select
                    v-model="newProgram"
                    label="Program"
                    :items="programsSelection"
                    multiple
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    v-model="newProgram"
                    label="Program"
                    :items="programsSelection"
                    item-text="Name"
                    item-value="Name"
                    multiple
                    readonly
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-autocomplete
                    :items="estatus"
                    outlined
                    label="Status"
                    v-model="newStatus"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" sm="12" md="6">
                                        <v-select
                                            label="Security Question"
                                        ></v-select>
                                        </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            v-model="newSecurityQuestion"
                                            label="Security Answer"
                                        ></v-text-field>
                                    </v-col> -->
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="#259647"
            @click="addEmployee()"
            v-if="newEmployee"
            >Save</v-btn
          >
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editdialog" max-width="75%">
      <v-card>
        <v-card-title class="primary">
          <span class="headline white--text">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="newName"
                    label="Staff Name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="newPhone"
                    label="Phone Number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-menu
                    ref="birthMenu"
                    v-model="birthMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="birthDate"
                        label="Birthday"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="birthDate"
                      :active-picker.sync="activePicker"
                      :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="$refs.birthMenu.save(birthDate)"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-menu
                    ref="anniversaryMenu"
                    v-model="anniversaryMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="anniversaryDate"
                        label="Anniversary date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="anniversaryDate"
                      :active-picker.sync="activePicker"
                      :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="$refs.anniversaryMenu.save(anniversaryDate)"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="newPhoneCarrier"
                    label="Phone Carrier"
                    :rules="requiredField"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="newEmail"
                        label="Email"
                        v-on="on"
                        :disabled="editEmail"
                        :rules="emailRules"
                      ></v-text-field>
                    </template>
                    <span
                      >This email will be used to login in the account.</span
                    >
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-menu offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Date Hired"
                        v-on="on"
                        :value="newDate"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="newDate" scrollable></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="newAddress"
                    label="Address"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field v-model="newCity" label="City"></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field v-model="newState" label="State"></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field v-model="newZip" label="Zip"></v-text-field>
                </v-col>
                <!-- <v-col class="d-flex" cols="12" sm="6">
                                        <v-autocomplete
                                        :items="position"
                                        outlined
                                        label="Position"
                                        v-model="newPosition"
                                        ></v-autocomplete>
                                    </v-col> -->
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    :items="droles"
                    label="Role"
                    outlined
                    v-model="newRole"
                  ></v-select>
                </v-col>
                <v-col
                  class="d-flex"
                  cols="12"
                  sm="6"
                  v-if="Role == 'Administration'"
                >
                  <v-select
                    v-model="newProgram"
                    label="Program"
                    :items="programsSelection"
                    item-text="Name"
                    item-value="Name"
                    multiple
                  ></v-select>
                </v-col>
                <v-col
                  class="d-flex"
                  cols="12"
                  sm="6"
                  v-if="Role != 'Administration'"
                >
                  <v-select
                    v-model="newProgram"
                    label="Program"
                    :items="programsSelection"
                    item-text="Name"
                    item-value="Name"
                    multiple
                    readonly
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-autocomplete
                    :items="estatus"
                    outlined
                    label="Status"
                    v-model="newStatus"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" sm="12" md="6">
                                        <v-select
                                            label="Security Question"
                                        ></v-select>
                                        </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            v-model="newSecurityQuestion"
                                            label="Security Answer"
                                        ></v-text-field>
                                    </v-col> -->
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text" color="#259647"
            @click="updateEmployee()"
            v-if="editEmployee"
            >Update</v-btn
          >
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="passdialog" max-width="75%">
      <v-card>
        <v-card-title>
          <span class="headline">Change Password</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="newPassword"
                    type="password"
                    label="Password"
                    :rules="requiredField"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="newRePass"
                    type="password"
                    label="Retype Password"
                    :rules="requiredField"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click="updatePassword()"
            >Update</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="print">
      <report-header>
        <h2>All Staff</h2>
      </report-header>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="employees"
            sort-by="Name"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Staff"
            :items-per-page="-1"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import ReportHeader from '@/components/Report/ReportHeader.vue';
import ReportListActions from '@/components/Report/ReportListActions.vue';
import ReportFilters from '@/mixins/reportFilters.js';

const url = require("../../client_config/config").url;

export default {
  mixins: [
      ReportFilters,
  ],
  components: {
    ReportHeader,
    ReportListActions
  },
  data: () => ({
    headers: [
      {
        text: "Name",
        align: "start",
        sortable: true,
        value: "Name",
      },
      { text: "Legal Name", value: "LegalName" },
      { text: "Position", value: "Role" },
      { text: "Programs", value: "Program", width: "25%"},
      { text: "Hire Date", value: "Date" },
      { text: "Birthday", value: "BirthDate" },
      { text: "Anniversary", value: "AnniversaryDate" },
      { text: "Status", value: "Status" },
      { text: "", value: "select" },
    ],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    employees: [],
    dialog: false,
    editClient: false,
    newClient: false,
    msg: false,
    search: "",
    text: "",
    menu3: false,
    menu: false,
    units: [],
    codes: [],
    gender: ["Male", "Female"],
    unitID: localStorage.getItem("unitID"),
    userProgram: JSON.parse(localStorage.getItem("userPrograms")),
    userState: localStorage.getItem("userState"),
    userRole: localStorage.getItem("userRole"),
    titleForm: "New Client",
    clientID: "",
    savedID: "",
    newName: "",
    newAdmissionDate: new Date(),
    newServiceCode: [],
    newProgram: [],
    newBio: "",
    newBirthday: "",
    newAge: "",
    newGender: "",
    newEthnicity: "",
    newAllergies: "",
    newBehaviors: "",
    newMedicare: "",
    newMedicaid: "",
    newPID: "",
    newCase: "",
    newWellsky: "",
    newDiagnoses: "",
    newState: "",
    newAdaptiveEquipment: false,
    newAdaptiveDate: "",
    newEquipmentUsed: "",
    newDailyUse: false,
    newExplanation: "",
    newAddress: "",
    newCity: "",
    newAddressState: "",
    newZip: "",
    states: ["Utah", "Nevada"],

    //missing data models
    newRePass: "",
    requiredField:  [
          v => !!v || 'This is required',
      ],
      emailRules: [
          v => !!v || 'This is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    newPassword: "",
    passdialog: "",
    editEmployee: "",
    newStatus: "",
    estatus: ["Full-Time", "Part-Time"],
    programs: "",
    newRole: "",
    newDate: "",
    newPhoneCarrier: "",
    newPhone: "",
    editdialog: "",
    newEmployee: "",
    // end of mising data models

    textFieldProps: {
      appendIcon: "event",
    },
    startDateProps: {
      min: moment(new Date()).format("YYYY-MM-DD"),
    },
    startTimeProps: {
      ampmInTitle: true,
    },
    endTimeProps: {
      ampmInTitle: true,
    },

    isLoading: true,
    showButton: false,
    programsSelection: [],
    filterProgram: "",
    filterRole: "",
    birthMenu: false,
    anniversaryMenu: false,
    activePicker: null,
    birthDate: null,
    anniversaryDate: null,
    page: 1,
    pageCount: 1,
    itemCount: 0,
    options: {},
    Role: localStorage.getItem("userRole"),
    reportListFilename: 'Staff List',
    reportFilters:  {
      filterProgram: '',
      filterRole: '',
    },
    reportFilterName: 'ReportFilters_StaffList',
  }),

  computed: {
    ...mapState({
      positions: "userRoles",
      droles: "userRoles",
    }),
    filteredPositions: function () {
      return this.positions.filter((role) => {
        return role !== "SuperAdministrator" && role !== "Client";
      });
    },


    queryParams() {
      let {page, sortBy, sortDesc, itemsPerPage} = this.options;
      const sortField = sortBy ? sortBy[0] : 'Date';
      const sortDirection = sortDesc ? sortDesc[0] : 'desc';
      const companyIds = localStorage.getItem("userCompanies");

      return {
        Company: JSON.parse(companyIds),
        program: this.reportFilters.filterProgram,
        role: this.reportFilters.filterRole,
        page: page,
        limit: itemsPerPage,
        sortField: sortField,
        sortDirection: sortDirection,
        userState: this.userState
      };

    },

    reportOptions() {
      return {
          query: this.queryParams,
          endpoints: `employees/report/printActiveEmployees`,
          dynamic: true
      }
    }
  },

  created() {
    this.getPrograms();
    this.getEmployees();
    this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
  },

  watch: {
      options: {
          handler() {
              this.getEmployees();
          },
          deep: true
      },
      reportFilters: {
          handler(newVal) {
            this.setReportFilters(this.reportFilterName, newVal);
          },
          deep: true
      }
  },

  methods: {
    initialize() {
      this.employees = [];
    },

    async getPrograms() {
      const companyIds = localStorage.getItem("userCompanies");

      await axios
        .get(`${url}/units/state/${this.userState}`, {
          params: {
            Company: JSON.parse(companyIds),
          },
        })
        .then((res) => {
          this.programsSelection = res.data.units;
        });
    },

    getEmployees: function () {
      this.isLoading = true;
      this.employees = [];

      axios
        .get(`${url}/employees/paginated/${localStorage.getItem("userState")}`, {
          params: this.queryParams

        })
        .then((res) => {
          var temp = res.data.docs || [];

          const { totalPages, totalDocs } = res.data;
          this.pageCount = totalPages || 0;
          this.itemCount = totalDocs || 0;

          for (var i = 0; i < temp.length; i++) {
            temp[i].BirthDate = this.checkDate(temp[i].BirthDate);
            temp[i].AnniversaryDate = this.checkDate(temp[i].AnniversaryDate);
            temp[i].Date = this.checkDate(temp[i].Date);
            this.employees.push(temp[i]);
          }
        })
        .catch(error => {
            console.error('Failed to fetch employees:', error);
        })
        .finally(() => (this.isLoading = false));
    },

    getUnits: function () {
      axios.get(`${url}/units`).then(async (res) => {
        this.units = res.data.units;
      });
    },
    getCodes: function () {
      axios.get(`${url}/codes`).then(async (res) => {
        this.codes = res.data.codes;
      });
    },

    close() {
      this.dialog = false;
      this.editdialog = false;
    },

    viewEmployee(item) {
      this.titleForm = "Viewing " + item.Name;
      this.editEmail = true;
      this.editdialog = true;
      this.editEmployee = true;
      this.newEmployee = false;
      this.newName = item.Name;
      this.newPhone = item.PhoneNumber;
      this.newEmail = item.Email;
      this.newAddress = item.Address;
      this.newCity = item.City;
      this.newState = item.State;
      this.newZip = item.Zip;
      this.newPosition = item.Position;
      this.newStatus = item.Status;
      this.newRole = item.Role;
      this.newPhoneCarrier = item.PhoneCarrier;
      this.newProgram = item.Program;
      this.employeeID = item._id;
      this.birthDate = this.checkDate(item.BirthDate);
      this.anniversaryDate = this.checkDate(item.AnniversaryDate);
      this.newDate =this.checkDate(item.Date);
    },

    updateEmployee() {
      var req_body = {
        Name: this.newName,
        PhoneNumber: this.newPhone,
        PhoneCarrier: this.newPhoneCarrier,
        Role: this.newRole,
        Program: this.newProgram,
        Email: this.newEmail,
        BirthDate: this.birthDate,
        AnniversaryDate: this.anniversaryDate,
        Date: this.newDate,
        Address: this.newAddress,
        City: this.newCity,
        State: this.newState,
        Zip: this.newZip,
        Position: this.newPosition,
        Status: this.newStatus,
        SecurityQuestion: this.newSecurityQuestion,
      };
      axios
        .put(`${url}/employees/${this.employeeID}`, req_body)
        .then((response) => {
          this.getEmployees();
          if (response.status == 400) {
            response.json().then(function (data) {
              alert(data.msg);
            });
          }
          this.newName = "";
          this.newEmail = "";
          this.newPassword = "";
          this.newRePass = "";
          this.newRole = "";
          this.newDate = "";
          this.newProgram = [];
          this.newPhone = "";
          this.newPhoneCarrier = "";
          this.newAddress = "";
          this.newCity = "";
          this.newState = "";
          this.newZip = "";
          this.newPosition = "";
          this.newStatus = "";
          this.newSecurityQuestion = "";
          this.msg = true;
          this.text = "The staff has been updated successfully.";
        });
      this.close();
    },

    printTable() {
      window.print();
    },

    checkDate(date){
      let isDateValid = isNaN(Date.parse(date))
      if(isDateValid){
        return date = ""
      }
      return moment(date).format('YYYY-MM-DD')
    }
  },
};
</script>
<style>
#print {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #print {
    display: block;
    border: none;
    width: 1400px;
    padding-right: 250px;
    margin-left: -300px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
